<template>
  <div v-if="currentOf">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Suivis des OFs'"
          :description="'Détails de l\'OF'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="currentOf.document">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence OF : {{ currentOf.document.reference }}
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      :class="[
                        {
                          'text-warning': currentOf.statut === 0,
                          'text-success':
                            currentOf.statut === 1 || currentOf.statut === 3,
                          'text-danger': currentOf.statut === 2,
                        }, of.MDI_CHECKBOX_CIRCLE, 'mr-1'                      ]"
                    ></i>
                    {{ getStatutOF(currentOf.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-6">
        <div class="table-rsesponsive" style="background: white">
          <table class="table table-detail">
            <tbody>
              <tr>
                <td>
                  <i :class='of.ICON_CALENDAR' class="text-custom-primary"></i>
                  <span class="font-weight-bold"> Date de création</span>
                </td>
                <td>
                  {{ currentOf.document.created_at | formatDate('DD/MM/YYYY') }}
                </td>
              </tr>

              <tr>
                <td>
                  <i :class='of.ICON_INFO_CIRCLE' class="text-custom-primary"></i>
                  <span class="font-weight-bold"> Libellé</span>
                </td>
                <td>{{ currentOf.libelle }}</td>
              </tr>

              <tr>
                <td>
                  <i :class='of.ICON_INFO_CIRCLE' class="text-custom-primary"></i>
                  <span class="font-weight-bold"> Nomenclature</span>
                </td>
                <td>
                  {{ currentOf.nomenclature.libelle }}
                </td>
              </tr>

              <tr>
                <td>
                  <i :class='of.ICON_INFO_CIRCLE' class="text-custom-primary"></i>
                  <span class="font-weight-bold"> Priorité</span>
                </td>
                <td>
                  <span :style="{ color: currentOf.priorite.couleur }">
                    {{ currentOf.priorite.nom }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <i :class='of.ICON_USER' class="text-custom-primary"></i>
                  <span class="font-weight-bold"> Auteur</span>
                </td>
                <td class="text-primary">
                  {{
                    currentOf.created_by.prenom
                      ? currentOf.created_by.prenom +
                        ' ' +
                        currentOf.created_by.nom
                      : currentOf.created_by.nom
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
        <div class="table-rsesponsive" style="background: white">
          <table class="table table-detail">
            <tbody>
              <tr>
                <td>
                  <i :class='of.ICON_CALENDAR' class="text-custom-primary"></i>
                  <span class="font-weight-bold"> Date du besoin</span>
                </td>
                <td>{{ currentOf.date_besoin }}</td>
              </tr>

              <tr>
                <td>
                  <i :class='of.ICON_INFO_CIRCLE' class="text-custom-primary"></i>
                  <span class="font-weight-bold"> Produit concerné</span>
                </td>
                <td>
                  {{ currentOf.produit.designation }}
                </td>
              </tr>

              <tr>
                <td>
                  <i :class='of.ICON_INFO_CIRCLE' class="text-custom-primary"></i>
                  <span class="font-weight-bold"> Quantité à fabriquer</span>
                </td>
                <td>
                  {{ currentOf.quantite + ' ' + currentOf.produit.unite }}
                </td>
              </tr>

              <tr>
                <td>
                  <i :class='of.ICON_INFO_CIRCLE' class="text-custom-primary"></i>
                  <span class="font-weight-bold"> Avancement</span>
                </td>
                <td>0 %</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="mt-4 mt-lg-2 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{ name: 'gpao_suivi_of_detail', params: { id: id } }"
              exact
              exact-active-class="active"
              ><i :class='of.ICON_LIST' class="text-custom-primary font-size-17"></i> Liste
              des étapes</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'gpao_suivi_of_detail-rapport',
                params: {
                  id: id,
                },
              }"
              exact
              exact-active-class="active"
              ><i :class='of.ICON_TACHOMETER' class="text-custom-primary font-size-17"></i>
              Rapport</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/gpao/of';
import { of } from '@/icons/gpao/suivi-of'
export default {
  data() {
    return {
      of,

      id: null,
      currentOf: null,
      title: 'Suivi des OFs - Détail',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    init() {
      this.id = this.$route.params.id;

      window.axios
        .get(URL.OF + '/' + this.id, { params: { suivi_of: true } })
        .then((resp) => {
          this.currentOf = resp.data.of;
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
